import { Button, message } from "antd";
import { ArrowRightOutlined, BackwardFilled } from "@ant-design/icons";
import { WplywContext } from "../../../../../context/wplywContext";
import { useAuth } from "../../../../../context/AuthContext";
import axios from "../../../../../context/axiosConfig";
import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useCheckStages } from "./CheckStage";
import ConfirmStatus, { ConfirmStatusManualStage } from "./ConfirmStatus";
import { useActiveTab } from "../../../../../context/activeTabContext";
import isCan from "../../../../../components/isCan";

const ConfirmButton = () => {
	const { wplyw, setWplyw } = useContext(WplywContext); // Kontekst dla wplyw
	const { user } = useAuth(); // Dane użytkownika z kontekstu autoryzacji
	const { activeTabX } = useActiveTab(); // Aktywna zakładka z kontekstu
	const { wplywid } = useParams();
	const navigate = useNavigate();
	const [cando, setCando] = useState(false); // Stan dla uprawnień
	const status = useCheckStages(); // Status etapu
	const perms = user.perms;
	const activePersonOwnId =
		activeTabX?.activeKey === "3" ? localStorage.getItem("personid") : null;
	const activePerson =
		activePersonOwnId && wplyw?.wplyw_data?.data?.msr_wplywy?.msr_persons
			? wplyw.wplyw_data.data.msr_wplywy.msr_persons.find(
					(p) =>
						String(p?.msr_persons_own_id) ===
						String(activePersonOwnId),
				)
			: null;
	const isGeneratedTransferLocked = Boolean(
		activeTabX?.activeKey === "3" &&
		(activeTabX?.innerActiveKey === "1" ||
			activeTabX?.innerActiveKey === "2") &&
		(Boolean(activePerson?.msr_persons_transfers_generated_file) ||
			Boolean(activePerson?.msr_reserves_generated_file) ||
			Boolean(
				(activePerson?.msr_transfers || []).some(
					(t) => t?.msr_transfers_generated_file,
				),
			)),
	);

	// Użycie useEffect do ustawiania wymaganych uprawnień
	useEffect(() => {
		const fetchPermissions = async () => {
			let requiredPerms = [];
			if (activeTabX.activeKey == "1") {
				requiredPerms = ["can_confirm_dane_wplywu"];
			} else if (
				activeTabX.activeKey == "3" &&
				activeTabX.innerActiveKey == "1"
			) {
				requiredPerms = ["can_confirm_kwoty"];
			} else if (
				activeTabX.activeKey == "3" &&
				activeTabX.innerActiveKey == "2"
			) {
				requiredPerms = ["can_confirm_rachunki"];
			}
			// Dodaj inne warunki, jeśli potrzebne
			const result = await isCan(requiredPerms, perms);
			setCando(result);
		};
		fetchPermissions();
	}, [activeTabX, perms]);

	// Funkcja zapisu danych do bazy
	const saveDataToDatabase = async () => {
		const hide = message.loading("Zapisywanie danych...", 0); // Wyświetlenie komunikatu ładowania
		try {
			const response = await axios.post("/wplyw/update/data", {
				wplyw: wplyw.wplyw_data.data.msr_wplywy,
				userid: user.user.mlg_users_id,
				changes: wplyw.changes,
				status: status,
			});

			if (response.data.status) {
				message.success("Dane zapisane pomyślnie!");
				const savedId = response.data?.id;
				if (wplywid === "nowy" && savedId) {
					navigate(`/wplywy/${savedId}`, {
						bypassBlocker: true,
					});
					setWplyw((prev) => ({
						...prev,
						msr_wplywy_id: savedId,
						reload: !prev.reload,
						changes: [],
						mode: "preview",
						saved: true,
					}));
				} else {
					setWplyw((prev) => ({
						...prev,
						reload: !prev.reload,
						changes: [],
						mode: "preview",
					}));
				}
			} else {
				message.error(`Błąd zapisu: ${response.data.message}`);
			}
		} catch (error) {
			console.error("Error saving data:", error);
			const serverMessage = error?.response?.data?.message;
			message.error(
				serverMessage
					? `Błąd zapisu: ${serverMessage}`
					: "Wystąpił błąd podczas zapisywania danych.",
			);
		} finally {
			hide();
		}
	};

	// Funkcja cofania zatwierdzenia
	const unconfirm = async () => {
		try {
			const response = await axios.post("/wplyw/unconfirm", {
				wplyw: wplyw.wplyw_data.data.msr_wplywy,
				status: status,
			});

			if (response.data.status) {
				message.success("Cofnięto zatwierdzenie!");
				setWplyw({ ...wplyw, reload: !wplyw.reload });
			} else {
				message.error(`Błąd zapisu: ${response.data.message}`);
			}
		} catch (error) {
			console.error("Error unconfirming data:", error);
			const serverMessage = error?.response?.data?.message;
			message.error(
				serverMessage
					? `Błąd cofania zatwierdzenia: ${serverMessage}`
					: "Wystąpił błąd podczas cofania zatwierdzenia.",
			);
		}
	};

	// Wywołanie funkcji sprawdzających statusy
	const isConfirmed = ConfirmStatus();
	const isManualStage = ConfirmStatusManualStage(true);

	// Warunki wyświetlania przycisków
	if (
		activeTabX.activeKey === "2" ||
		(activeTabX.activeKey === "3" && activeTabX.innerActiveKey === "3")
	) {
		return null; // Nie renderuj przycisków
	}

	return (
		cando &&
		(isConfirmed ? (
			<Button
				icon={<BackwardFilled />}
				onClick={unconfirm}
				disabled={!cando || isGeneratedTransferLocked}
			>
				Cofnij zatwierdzenie
			</Button>
		) : (
			<Button
				type="primary"
				disabled={!isManualStage || !cando || isGeneratedTransferLocked}
				icon={<ArrowRightOutlined />}
				onClick={saveDataToDatabase}
			>
				Zapisz i zatwierdź
			</Button>
		))
	);
};

export default ConfirmButton;
